import React, { useEffect, useState, useRef } from 'react';
import axios from 'axios';
import { RotatingLines } from 'react-loader-spinner';
import { toast, ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { useNavigate, Link } from "react-router-dom";
function StreetCustomer() {
    const [loading, setLoading] = useState(true);
    const [stbCount, setStbCount] = useState(0);
    const [isButtonDisabled, setIsButtonDisabled] = useState(false);
    const [error, setError] = useState(null);
    const [streetName, setStreetName] = useState([]);
    const [streetNetwork, setStreetNetwork] = useState([]);
    const [staffCode, setStaffCode] = useState([]);
    const [allCustomer, setAllCustomer] = useState([]);
    const navigate = useNavigate();
    const user = getCookie("user");
    const [currentPage, setCurrentPage] = useState(1);
    const [rowsPerPage] = useState(100);
    const [searchQuery, setSearchQuery] = useState("");
    const [formData, setFormData] = useState({ area_code: "", street: "", network: "" });
    const [isEditMode, setIsEditMode] = useState(false);
    const [editId, setEditId] = useState(null);
    const [previousData, setPreviousData] = useState(null); // ✅ Add State for Previous Data
        const formRef = useRef(null);
    function getCookie(name) {
        const cookies = document.cookie.split("; ");
        for (const cookie of cookies) {
            const [key, value] = cookie.split("=");
            if (key === name) return value;
        }
        return null;
    }
    if (!user) navigate("/");
    const ViewClick = (id) => {
        navigate(`/StreetExecutiveView/${id}`, { user });
    };

    // Handle Input Change
    const handleChange = (e) => {
        setFormData(prev => ({ ...prev, [e.target.name]: e.target.value || "" }));
    };



    const handleEditClick = (streetData) => {
        console.log("Editing Data:", streetData); // Debugging
        setIsEditMode(true);
        setEditId(streetData.id);
    
        setFormData({
            area_code: streetData.area_code || "",
            street: streetData.street_name || "",  // ✅ Use `street_name`
            network: streetData.network_name || ""  // ✅ Use `network_name`
        });
    
        setPreviousData({
            area_code: streetData.area_code || "",
            street: streetData.street_name || "",  // ✅ Use `street_name`
            network: streetData.network_name || ""  // ✅ Use `network_name`
        });
        if (formRef.current) {
            formRef.current.scrollIntoView({ behavior: "smooth", block: "start" });
        }
    };
    
    const handleSubmit = async (e) => {
        e.preventDefault();
        setIsButtonDisabled(true);

        console.log("🔍 Debugging formData:", formData);

        // ✅ Ensure validation properly ends if data is missing
        if (!formData.area_code.trim() || !formData.street.trim() || !formData.network.trim()) {
            toast.error("❌ All fields (area_code, street, network) are required.");
            setIsButtonDisabled(false);
            return;  // ✅ Properly exit the function
        }

        try {
            let response;
            if (isEditMode) {
                response = await axios.post(`https://node.cabletvpay.in/streetSpecific`, {
                    id: editId,
                    user,
                    area_code: formData.area_code,
                    street: formData.street,
                    network: formData.network,
                    get_street_name: previousData?.street || "",  // Ensure it's not undefined
                    get_network_name: previousData?.network || "",
                    get_area_code: previousData?.area_code || ""
                });
            }
            else {
                response = await axios.post("https://node.cabletvpay.in/AddstreetSpecific", { user, ...formData });
            }

            console.log("✅ Server Response:", response.data);
            toast.success(isEditMode ? "Street updated successfully!" : "Street added successfully!");

            // ✅ Reset the form and states
            setFormData({ area_code: "", street: "", network: "" });
            setIsEditMode(false);
            setEditId(null);
            fetchUserData();

        } catch (error) {
            console.error("❌ Error saving data:", error.response?.data || error);
            toast.error(error.response?.data?.message || "Failed to save street details.");
        } finally {
            setIsButtonDisabled(false);
        }
    };

    const fetchUserData = async () => {
        try {
            const response = await axios.post('https://node.cabletvpay.in/streetGetInfo', { user });
            if (response.status === 200) {
                console.log(response.data);
                setStaffCode(response.data.staffCode);
                setStreetName(response.data.streetDetails);
                setAllCustomer(response.data.net_name);
                setStreetNetwork(response.data.streetNetwork);

            }
        } catch (err) { setError(err.response?.data?.message || "Error fetching data"); }
        finally { setLoading(false); }
    };

    const handleDelete = async (id) => {
        try {
            const response = await axios.post(`https://node.cabletvpay.in/deleteStreet`, { user, id });
            if (response.status === 200) {
                toast.success("Staff deleted successfully.");
                fetchUserData();
            }
        } catch (err) {
            toast.error(err.response?.data?.message || "Error deleting staff");
        }
    };
    useEffect(() => { fetchUserData(); }, []);

    const handleClear = () => {
        setIsEditMode(false);
        setEditId(null);
        setFormData({ area_code: "", street: "", network: "" });
    };
    const indexOfLastRow = currentPage * rowsPerPage;
    const indexOfFirstRow = indexOfLastRow - rowsPerPage;
    const currentRows = streetName.slice(indexOfFirstRow, indexOfLastRow);
    const paginate = (pageNumber) => setCurrentPage(pageNumber);
    const totalPages = Math.ceil(streetName.length / rowsPerPage);
    const filteredRows = currentRows.filter((row) => Object.values(row).some(value => String(value).toLowerCase().includes(searchQuery.toLowerCase())));

    const downloadCSV = () => {
        const headers = ["Sno", "Customer__Name", "Acc_no", "Code", "STB_no", "D_no", "Flat_name", "Street__name", "Phone", "Pay Status", "Plan Amount", "Paid Amount", "Paid_Date", "Balance Amount", "Discount Amount", "Advance Amount", "Pending Amount", "Staff__Code", "Network", "Paid_time", "Package", "Added_date", "Collection Staff"];
        const csvRows = [];
        csvRows.push(headers.join(","));
        staffCode.forEach(row => { csvRows.push([row.id, row.name, row.account_num, row.acc_num, row.serial_num, row.doorno, row.flat_name, row.street, row.mobile, row.status, row.pay_amt, row.paid_amt, row.paid_date, row.balance, row.discount, row.extra_Balance_amt, row.pend_amt, row.area_code, row.net_name, row.paid_time, row.package, row.adate, row.col_boy].join(",")); });
        const blob = new Blob([csvRows.join("\n")], { type: "text/csv;charset=utf-8;" });
        const link = document.createElement("a");
        const url = URL.createObjectURL(blob);
        link.setAttribute("href", url);
        link.setAttribute("download", "CableTvPay.csv");
        link.style.visibility = "hidden";
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        URL.revokeObjectURL(url);
    };
    if (loading) return (
        <div className="content-wrapper d-flex justify-content-center align-items-center" style={{ height: "80vh" }}>
            <RotatingLines visible={true} height="80" width="80" strokeColor="#007bff" strokeWidth="2" animationDuration="0.75" />
        </div>
    );

    if (error) return <div className='d-flex justify-content-center align-items-center min-vh-100'>Error: {error}</div>;

    return (
        <div className="content-wrapper">
            <div className="content-header pt-1">
                <div className="my-3">
                    <div className="fs-4 valuesDec h4">COLLECTION STAFF STREET DETAILS</div>
                    <div style={{ position: 'absolute', top: '30px' }}><ToastContainer theme='dark' /></div>
                </div>
                <hr />
                <div className="mt-3 mb-2 mb-lg-5">
                    <div className="">
                        <form ref={formRef} onSubmit={handleSubmit}>
                            <div className="row mx-3 d-flex justify-content-center">

                                <div className="col-lg-3 col-md-6 col-12 mb-2">
                                    <div className="form-group">
                                        <label htmlFor="area_code" className="text-center valuesDec text-navy">Staff Code</label>
                                        <select className="form-control bg-gradient-navy text-white border-0 elevation-3"
                                            id="area_code" name="area_code" value={formData.area_code} onChange={handleChange}>
                                            <option className='bg-light' value="">None</option>
                                            {staffCode.map((row, index) => (
                                                <option className='bg-light' key={index} value={row.staffCode}>
                                                    {row.name} - ({row.staffCode})
                                                </option>
                                            ))}
                                        </select>
                                    </div>
                                </div>


                                <div className="col-lg-3 col-md-6 col-12 mb-2">
                                    <div className="form-group">
                                        <label htmlFor="street" className="text-center valuesDec text-navy">Enter Street Name</label>
                                        <input 
                                            className="form-control bg-gradient-navy text-white border-0 elevation-3"
                                            id="street"
                                            name="street"
                                            type="text"
                                            placeholder="Street Names.."
                                            value={formData.street || ""}
                                            onChange={handleChange}
                                            list="street-opt"
                                        />
                                        <datalist id="street-opt">
                                            {streetName.map((row, index) => (
                                                <option className="bg-light" key={index} value={row.street_name}>
                                                    {row.street_name}
                                                </option>
                                            ))}
                                        </datalist>
                                    </div>
                                </div>
                                <div className="col-lg-3 col-md-6 col-12 mb-2">
                                    <div className="form-group">
                                        <label htmlFor="network" className="text-center valuesDec text-navy">Enter Network Name</label>
                                        <input 
                                            className="form-control bg-gradient-navy text-white border-0 elevation-3"
                                            id="network"
                                            name="network"
                                            type="text"
                                            placeholder="Network Name..."
                                            value={formData.network || ""}
                                            onChange={handleChange}
                                            list="network-opt"
                                        />
                                        <datalist id="network-opt">
                                            {streetNetwork.map((row, index) => (
                                                <option className="bg-light" key={index} value={row.network_name}>
                                                    {row.network_name}
                                                </option>
                                            ))}
                                        </datalist>
                                    </div>
                                </div>
                                <div className="col-lg-2 col-md-3 mt-md-2 pt-2 pt-md-4 col-6 mb-2 d-flex justify-content-center">
                                    <input type="submit" className="btn border-0 h-75 bg-info filterBtn text-light pb-3 pb-lg-1 w-100"
                                        disabled={isButtonDisabled} value={isEditMode ? "Update Street" : "Add Street"} />
                                </div>

                                <div className="col-lg-1 col-md-3 mt-md-2 pt-2 pt-md-4 col-6 mb-2 d-flex justify-content-center">
                                    <button type="button" className="btn border-0 bg-danger filterBtn text-light h-75 pb-3 pb-lg-1 w-100"
                                        onClick={handleClear}> Clear </button>
                                </div>
                            </div>
                        </form>
                    </div>
                </div>
                <div className="card shadow-lg mt-3 mt-lg-5 " style={{ border: "2px solid white" }}>
                    <div className="card-header filterBtn ">
                        <div className="row">
                            <div className="col-lg-4">
                                <div className="text-left mb-lg-0 w-50">
                                    <h3 className="pb-0 mb-0 mt-1 px-0 nav-link text-navy">Filter Details</h3>
                                </div>
                            </div>
                            <div className="col-lg-8 mt-1">
                                <span>
                                    <div className="row w-auto">
                                        <div className="col-11 col-lg-6">
                                            <div className="input-group">
                                                <input type="text" className="form-control text-navy bg-light border-0 px-1 py-0" placeholder="Search..." value={searchQuery} onChange={(e) => setSearchQuery(e.target.value)} style={{ borderRadius: "5px 0 0 5px" }} />
                                                <span className="input-group-text bg-light text-navy border-0 px-2" id="basic-addon1" style={{ borderRadius: "0 5px 5px 0" }} > <i className="fas fa-search" /> </span>
                                            </div>
                                        </div>
                                        <div className="col-12 col-lg-6 mt-1 mt-lg-0">
                                            <div className="d-flex justify-content-end">
                                                <div className=" btn-group">
                                                    <button onClick={downloadCSV} className="btn btn-dark border-right px-lg-3 px-5 my-1 d-flex"><i className="fas fa-download pt-1 px-1" /> Download</button>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </span>
                            </div>
                        </div>
                    </div>
                    <div className="card-body p-0">
                        <table id="myTable" className="table table-striped bg-white table-bordered table-responsive-lg" style={{ backgroundColor: "rgba(151, 151, 151, 0.185)" }}>
                            <thead className="bg-gradient-navy">
                                <tr>
                                    <th>Sl_No</th>
                                    <th>Staff Code</th>
                                    <th>Staff Name</th>
                                    <th>Street Name</th>
                                    <th>Network Name</th>
                                    <th>Customer Details</th>
                                    <th>Edit</th>
                                    <th>Delete</th>
                                </tr>
                            </thead>
                            <tbody>
                                {filteredRows.length > 0 ? (
                                    filteredRows.map((row, index) => (
                                        <tr key={index}>
                                            <td className='tableText border-dark text-bold'>{row.id}</td>
                                            <td className='tableText border-dark text-bold'>{row.area_code}</td>
                                            <td className='tableText border-dark text-bold'>{row.executive_name}</td>
                                            <td className='tableText border-dark text-bold'>{row.street_name}</td>
                                            <td className='tableText border-dark text-bold'>{row.network_name}</td>
                                          
                                             <td className='tableText border-dark text-bold' onClick={() => ViewClick(row.id)}> <button className="btn btn-outline-info"> <i className="fas fa-eye"></i></button></td>
                                            <td className='tableText border-dark text-bold' onClick={() => handleEditClick(row)}>
                                                <button className="btn text-fuchsia"><i className="fas fa-edit"></i></button>
                                            </td>
                                            <td className='text-center'><button className='btn btn-danger' onClick={() => handleDelete(row.id)}><i className="fas fa-trash" /></button></td>
                                        </tr>
                                    ))) : (<tr><td colSpan="30">No results found</td></tr>)}
                            </tbody>
                        </table>
                    </div>

                    <div className="card-footer filterBtn">
                        <div className="d-flex justify-content-end">
                            <div className="pagination btn-group border-light">
                                <button className="btn btn-dark border-right" onClick={() => paginate(currentPage - 1)} disabled={currentPage === 1} style={{ opacity: currentPage === 1 ? 0.6 : 1 }} ><i className="fas fa-backward" /></button>
                                <button onClick={() => paginate(1)} className={`btn ${currentPage === 1 ? "bg-gradient-green border-light" : "btn-dark"} border-left`} > 1 </button>
                                {currentPage > 3 && <span className="mx-1">...</span>}
                                {Array.from({ length: 3 }, (_, i) => currentPage - 1 + i)
                                    .filter((page) => page > 1 && page < totalPages)
                                    .map((page) => (
                                        <button key={page} onClick={() => paginate(page)} className={`btn ${currentPage === page ? "bg-gradient-green border-light" : "btn-dark"}`} style={{ fontWeight: currentPage === page ? "bold" : "normal" }} > {page} </button>
                                    ))}
                                {currentPage < totalPages - 2 && <span className="mx-1">...</span>}
                                {totalPages > 1 && (
                                    <button onClick={() => paginate(totalPages)} className={`btn ${currentPage === totalPages ? "bg-gradient-green border-light" : "btn-dark"} border-right`} > {totalPages} </button>
                                )}
                                <button className="btn btn-dark  border-left" onClick={() => paginate(currentPage + 1)} disabled={currentPage === totalPages} style={{ opacity: currentPage === totalPages ? 0.6 : 1 }} > <i className="fas fa-forward"></i></button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}
export default StreetCustomer;
